import { Injectable } from '@angular/core';
import * as Sentry from '@sentry/angular';
import { Scope } from '@sentry/angular';
import { IFaultResponseDTO } from '../dto/response/fault/fault-response.dto';
import type { Primitive } from '@sentry/core/build/types/types-hoist/misc';
import { ISentryExceptionDTO } from '../dto/sentry/sentry-exception.dto';
import { HttpErrorResponse } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class SentryService {
  public captureException(sentryException: ISentryExceptionDTO): void {
    const tags: { [key: string]: Primitive } = {};
    const error: unknown = sentryException.error;
    if (error instanceof HttpErrorResponse && 0 !== error.status) {
      const faultResponseDTO: IFaultResponseDTO | null =
        error.error as IFaultResponseDTO;
      if (
        faultResponseDTO?.appName &&
        faultResponseDTO?.appVersion &&
        faultResponseDTO?.code
      ) {
        tags['backendName'] = faultResponseDTO.appName;
        tags['backendVersion'] = faultResponseDTO.appVersion;
        tags['backendFaultCode'] = faultResponseDTO.code;
      }
    }
    Sentry.captureException(error, (scope: Scope): Scope => {
      scope.setLevel(sentryException.severityLevel);
      scope.setTransactionName(sentryException.transactionName);
      scope.setTags(tags);
      if (sentryException.user) {
        scope.setUser(sentryException.user);
      }
      return scope;
    });
  }
}
